import React, {PropTypes} from 'react';

import * as color from '../../../constants/colors';

import FlatButton from '../../common/buttons/FlatButton';


class RhinoConfirm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      closing: false,
      bodyTop: 0,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = this.adjustHeight.bind(this);
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.open !== nextProps.open) {
      if(this.state.open && !nextProps.open && !this.state.closing) {
        this.closeConfirm();
      } 
      if(nextProps.open) {
        this.openConfirm();
      }
    }
  }

  getConfirmBody() {
    let confirm = null;
    let confirms = document.getElementsByClassName('confirmBody');
    for(let i = 0; i < confirms.length; i++) {
      if(getComputedStyle(confirms[i], null).display === 'block') {
        confirm = confirms[i];
        break;
      }
    }
    return confirm;
  }

  adjustHeight() {
    let foundConfirm = this.getConfirmBody();
    if(foundConfirm) {
      let offset = (window.innerHeight - (foundConfirm.offsetHeight + 128)) / 2;
      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  openConfirm() {
    this.setState({ open: true }, () => {
      let confirm = null;
      do {
        confirm = this.getConfirmBody();
        setTimeout(() => {
          if(confirm) {
            let offset = (window.innerHeight - (confirm.offsetHeight + 128)) / 2;
            this.setState({ 
              bodyTop: '64px',
              marginOffset: offset > 0 ? offset + 'px' : 0, 
            });
          }
        }, 25);
      } while(!confirm);
    });
  }

  closeConfirm() {
    this.setState({ 
      closing: true,
      bodyTop: '0',
    });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      });
    }, 400)
  }

  confirmStyles() {
    return {
      display: this.state.open ? 'block' : 'none', 
    }
  }

  getConfirmButtonName() {
    return this.props.confirmButtonName ? this.props.confirmButtonName : 'Confirm';
  }

  getConfirmButtonColor() {
    return this.props.confirmButtonColor ? this.props.confirmButtonColor : color.DD_PURPLE;
  }

  render() {

    return (
      <div 
        className={this.state.closing ? 'RhinoConfirm out' : 'RhinoConfirm'} 
        style={this.confirmStyles()}>
        <div 
          className='confirmBody'
          style={{
            display: this.state.open ? 'block' : 'none',
            top: this.state.bodyTop,
            marginTop: this.state.marginOffset,
            marginBottom: this.state.marginOffset === 0 ? '64px' : 0,
          }}>
          <div className='confirmTitle'>{this.props.confirmTitle}</div>
          <div className='confirmIcon'>
            <img src='/img/icons/lines/iconline_thin.svg' />
          </div>
          <div className='confirmText'>
            {this.props.confirmText}
          </div>
          <div className='confirmButtons'>
            <FlatButton
              className={this.props.confirmClassName || ''}
              label={this.getConfirmButtonName()}
              onClick={this.props.confirmMethod.bind(this)} />
            <FlatButton
              label='Cancel'
              onClick={this.props.cancelMethod.bind(this)} />
          </div>
        </div>
      </div>
    );
  }
}
export default RhinoConfirm;